import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@doxyme/ui';
import './reset-confirm-modal.scss';
const RESET_CONFIRM_IDS = {
    title: 'account.settings.clinic.branding.reset-confirm.title',
    text: 'account.settings.clinic.branding.reset-confirm.text',
    confirm: 'account.settings.clinic.branding.reset-confirm.confirm',
};
const RESTORE_ALL_CONFIRM_IDS = {
    title: 'account.settings.clinic.branding.restore-all-confirm.title',
    text: 'account.settings.clinic.branding.restore-all-confirm.text',
    confirm: 'account.settings.clinic.branding.restore-all-confirm.confirm',
};
export const ResetConfirmModal = ({ isOpen, onClose, onConfirm, restoreAll = false, }) => {
    const intl = useIntl();
    const formatMessage = intl.formatMessage.bind(intl);
    const ids = restoreAll ? RESTORE_ALL_CONFIRM_IDS : RESET_CONFIRM_IDS;
    return (<Modal ariaLabelledby="reset-confirm-modal" className="reset-confirm-modal" isOpen={isOpen} closeModal={onClose} closeOnOutsideClick>
      <ModalHeader>
        <h4 id="reset-confirm-modal">
          {formatMessage({ id: ids.title })}
        </h4>
      </ModalHeader>
      <ModalBody>
        {formatMessage({ id: ids.text })}
      </ModalBody>
      <ModalFooter>
        <div className="ui-modal-actions">
          <Button type="button" size="medium" onClick={onClose} btnStyle="outline" color="secondary">
            {formatMessage({ id: 'common.cancel' })}
          </Button>
          <Button type="button" size="medium" onClick={onConfirm} color="primary">
            {formatMessage({ id: ids.confirm })}
          </Button>
        </div>
      </ModalFooter>
    </Modal>);
};
